module.exports = __webpack_public_path__ + "static/img/2.8b18561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/9.8/2.png
// module id = 1Dw8
// module chunks = 0